export default "__VITE_ASSET__DWL4bH4p__"